<div class="kf-editable-field">
    <div class="d-flex
         {{'kf-field-xs-' + labelCols}}
         {{'kf-field-sm-' + labelColsSm}}
         {{'kf-field-md-' + labelColsMd}}
         {{'kf-field-lg-' + labelColsLg}}
         {{'kf-field-xl-' + labelColsXl}}
         {{'kf-field-xxl-' + labelColsXxl}}">
        <div class="kf-input-label">
            @if(isEditable$ | async) {
                <label for="{{id}}">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </label>
            }
            @else {
                <div class="kf-label">
                    {{label}}
                    @if (helpText) {
                        <span class="me-2 kf-tooltip" [ngbTooltip]="helpText" [placement]="['top', 'right']">
                            <i class="fas fa-info-circle"></i><span class="sr-only">{{helpText}}</span>
                        </span>
                    }
                </div>
            }
        </div>
        <!-- INPUT BOX version - Typeahead pop-up -->
        <ng-template #popup let-result="result" let-term="term">
            <div class="row d-block">
                <div class="d-inline p-0">
                    @if (result.img != undefined) {
                        <img src="{{result.img}}" class="rounded img-fluid" alt="Photo of {{result.name}}" />
                    }
                    @if (result.iconClass != undefined) {
                        <i class="{{result.iconClass}}"></i>
                    }
                </div>
                <div class="d-inline-block align-middle pe-4" [class.text-decoration-line-through]="!!result?.personId && !result?.isActive">
                    <ngb-highlight [result]="result.name" [term]="term" class="title"></ngb-highlight>
                    @if (result.desc != undefined) {
                        <div class="subtitle">{{result.desc}}</div>
                    }
                </div>
            </div>
        </ng-template>
        
        <!-- INPUT BOX -->
        <div class="kf-input col">
            @if (isEditable$ | async; as editable) {
                <div class="d-flex">
                    <input type="text" class="input-text w-100"
                           [(ngModel)]="_displayValue"
                           (ngModelChange)="onEdit($event)"
                           (selectItem)="onTypeaheadOptionSelect($event.item)"
                           [id]="id"
                           [placeholder]="placeholder"
                           [ngbTypeahead]="search"
                           popupClass="kf-typeahead"
                           (keyup.enter)="addValue()"
                           (keyup.arrowdown)="navigateResults($event)"
                           (keyup.arrowup)="navigateResults($event)"
                           (focus)="focusOpenTypeahead ? openTypeahead() : null"
                           (click)="focusOpenTypeahead ? openTypeahead() : null"
                           (blur)="onBlur()"
                           [resultTemplate]="popup"
                           [disabled]="isDisabled"
                           [inputFormatter]="formatInput"
                           #ngbInstance="ngbTypeahead"
                           #ngbElement />
                    <div class="ms-1">
                        @if (!isDisabled && !isSearching) {
                        <button type="button" class="kf-btn-xs kf-btn kf-btn-blue" (click)="addValue()"
                                [disabled]="!this._canAdd" title="Add">
                            <i class="fa-solid fa-plus"></i>
                        </button>
                        }
                        @if (isDisabled || isSearching) {
                            <div class="ms-1" style="height:28px">
                                <i class="fa-solid fa-spinner fa-spin"></i>
                            </div>
                        }
                    </div>
                </div>
            }
            
            <!--  VALUE DISPLAY  -->
            <div class="container mx-0">
                <div class="row">
                    @if (!!obj[prop]?.length) {
                        @for (val of obj[prop]; track $index; let last = $last) {
                            <button type="button" class="kf-btn-xs kf-btn kf-btn-light-blue d-flex justify-content-between px-2 mt-1 me-1 text-break"
                                    [style.width]="arrayItemWidth == undefined ? 'auto' : arrayItemWidth + 'px'"
                                    (click)="removeValue(val)"
                                    [disabled]="!(isEditable$ | async)">
                                <div>{{val.name}}</div>
                                @if (isEditable$ | async) {
                                    <div class="ms-2 p-0 fw-bold h-auto">X</div>
                                }
                            </button>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
    
    @if (isEditable$ | async; as editable) {
        <!--  Manual warning if allowed typed value is not added to the array  -->
        @if (_hasUnsavedText) {
            <observable-errors-warnings [nonInputWarnings]="[ _displayValue + ' has not been added to the list. Click + to add it.' ]"></observable-errors-warnings>
        }
        <!--  Errors/Warnings  -->
        <observable-errors-warnings [obj]="obj" [props]="[prop]" [useSingleAlert]="true"></observable-errors-warnings>
    }
</div>
